'use strict';

angular.module('app.schedule.noBroadcastDirective', [])
    .directive('noBroadcast', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/schedule/noBroadcast/noBroadcastView.html',
                link: function (scope, elm) {
                    return elm.addClass('no-broadcast-directive');
                }
            };
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/schedule/noBroadcast/noBroadcastDirective.js